import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface SelectedEntity {
  id: string
  name: string
}

interface SelectionState {
  // Current selections
  selectedRestaurant: SelectedEntity | null
  selectedBranch: SelectedEntity | null

  // Selection methods
  setSelectedRestaurant: (restaurant: SelectedEntity | null) => void
  setSelectedBranch: (branch: SelectedEntity | null) => void
  
  // Helper methods
  isRestaurantSelected: () => boolean
  isBranchSelected: () => boolean
  
  // Clear selections
  clearRestaurantSelection: () => void
  clearBranchSelection: () => void
  clearAllSelections: () => void
}

export const useSelectionStore = create<SelectionState>()(
  persist(
    (set, get) => ({
      selectedRestaurant: null,
      selectedBranch: null,

      setSelectedRestaurant: (restaurant) => {
        set({ selectedRestaurant: restaurant })
        // Clear branch selection when restaurant changes
        if (restaurant === null) {
          set({ selectedBranch: null })
        }
      },

      setSelectedBranch: (branch) => set({ selectedBranch: branch }),

      isRestaurantSelected: () => get().selectedRestaurant !== null,

      isBranchSelected: () => get().selectedBranch !== null,

      clearRestaurantSelection: () => set({ selectedRestaurant: null, selectedBranch: null }),

      clearBranchSelection: () => set({ selectedBranch: null }),

      clearAllSelections: () => set({
        selectedRestaurant: null,
        selectedBranch: null,
      }),
    }),
    {
      name: 'selection-store', // localStorage key
      partialize: (state) => ({
        selectedRestaurant: state.selectedRestaurant,
        selectedBranch: state.selectedBranch,
      }),
    }
  )
)
